<template>
	<mu-container fluid class="px-0">
        <mu-row>
			<lang-menu />
			<navbar-desktop class="navbar-desktop-menu"/>
			<navbar-mobile class="navbar-mobile-menu"/>
        </mu-row>
    </mu-container>
</template>

<script>
//COMPONENTS
import LangMenu from '@/components/NavBar/LangMenu'
import NavbarDesktop from '@/components/NavBar/NavbarDesktop'
import NavbarMobile from '@/components/NavBar/NavbarMobile'

// HELPERS
import _FrequentTravellerHelper from '@/store/helpers/frequenttraveller/frequenttraveller'
import _GlobalHelper from '@/store/helpers/global'
// IMG
import mx from '@@/images/mx.png'
import us from '@@/images/us.svg'
import icon from '@@/images/covid/icono-covid.png'
// VUEX
import { mapMutations, mapGetters } from 'vuex'
export default {
	name: 'nav-bar',
	components: {
		'navbar-desktop': NavbarDesktop,
		'lang-menu': LangMenu,
		'navbar-mobile': NavbarMobile
	},
	data() {
		return {
			open_drawer: false,
			activeTooltip: false,
			tab_active: 0,
			countries: [
				{
					img: mx,
					tag: 'es  (mx)'
				},
				{
					img: us,
					tag: 'en  (us)'
				}
			],
			select_country: mx,
			icon: icon,
			show_tour: true
		}
	},
	computed: {
		...mapGetters({
			language: _GlobalHelper.getters.language,
			profile: _FrequentTravellerHelper.mutations.profile
		}),

		lang: {
			set() {

			},
			get() {
				return this.language
			}
		},

		loading: {
			set(data) {
				this.setLoading(data)
			},
			get() {

			}
		}
	},
	watch: {
		travellerSession(data) {
			//console.log(data)
		}
	},
	methods: {
		...mapMutations({
			setLanguage: _GlobalHelper.mutations.language,
			setAlertSimple: _GlobalHelper.mutations.setAlertSimple,
			setAuthenticate: _GlobalHelper.mutations.setAuthenticate,
			setLoading: _GlobalHelper.mutations.loading,
			setPrfile: _FrequentTravellerHelper.mutations.profile
		}),

		changeLanguage(obj) {
			this.select_country = obj.img
			let lang = obj.tag.split(' ')
			this.setLanguage(lang[0])
		},

		checkLanguage() {
			for (let country of this.countries) {
				let lang = country.tag.split(' ')
				if (lang[0] === this.lang) {
					this.select_country = country.img
				}
			}
		},

		closeDrawer() {
			this.open_drawer = false
		},

		openSignIn() {
			this.setAuthenticate({
				show: true
			})
			this.open_drawer = false
		},
		logOut() {
			this.loading = {
				show: true,
				message: `
                <mu-container>
                    <h5>${this.$i18n.t('loading.logout')}</h5>
                </mu-container>`
            }

			this.activeTooltip = false
			setTimeout(() => {
				this.setPrfile(null)
				this.loading = { show: false, message: null }
			}, 500)
		},
	},
	created() {
		this.lang == 'es' ? (this.select_country = mx) : (this.select_country = us)
	}
}
</script>

<style lang="scss" scoped>
.items-mobile {
    .buttonLogoMobile {
        width: 20px !important;
        height: 20px !important;
    }
	.buttonLogoMobileCombined {
        width: 20px !important;
        height: 20px !important;
    }
    .buttonTextMobile {
        font-size: 0.75em;
        margin: 0px;
        color: white;
        text-decoration: none;
        line-height: 15px;
    }
}

@media only screen and (max-width: 899px) {
	.navbar-desktop-menu{
		display: none;
	}
	.navbar-mobile-menu{
		display: block;
	}
}
@media only screen and (min-width: 900px) {
	.navbar-desktop-menu{
		display: block;
	}
	.navbar-mobile-menu{
		display: none;
	}
}
</style>